export enum StaticGetEndpoints {
  // Form
  Title = '/form/title',

  // Formations
  AllFormationSessions = '/formations/all',

  // Auth
  CheckToken = '/auth/check',

  // Entity
  CurrentEntity = 'entity/current',
  //Entity - Pending
  CurrentPendingEntity = 'entity/pending/current',

  // Company
  CurrentCompany = 'company/current',
  CurrentCompanyNAF = 'company/current/NAF',
  AllCompanies = 'company/all',
  AllCompaniesConfirmed = 'company/all/confirmed',
  //Company - Pending
  CurrentPendingCompany = 'company/pending/current',

  // Consultations
  AllConsultations = 'consultations/all',

  AllCompanyConsultations = 'consultations/company/all',
  AllCompanyInProgressConsultations = 'consultations/company/in_progress',
  AllCompanyClosedConsultations = 'consultations/company/closed',

  AllCommercialInProgressConsultations = 'consultations/commercial/in_progress',

  Nafs = 'consultations/naf',
  AllNaf = 'consultations/naf/all',
  AllActiveNaf = 'consultations/naf/all_active',
  AllNafDomains = 'consultations/naf/domains/all',

  //Commercial
  AllCommerciaux = 'commercial/all/dir',
  AllCommerciauxList = 'commercial/all_list/dir',

  AllInvoices = 'commercial/invoices/all',
  CurrentInvoices = 'commercial/invoices/current',

  CurrentCommissions = 'commercial/commissions/current',
  CurrentCommissionsInvoices = 'commercial/commissions/invoices/current',
  
  CurrentBoostsInvoices = 'commercial/boosts/invoices/current',

  //Commercial
  AllProspects = 'prospect/all',
  AllCOMProspects = 'prospect/COM',
  AllDIRProspects = 'prospect/DIR',
  PendingProspects = 'prospect/pending',

  //Plans
  AllPlansENT = 'plans/all/ENT',

  //Users
  CurrentUserInfos = 'users/current/infos',
  CurrentUserLogo = 'users/current/logo',
  
  SubUsersENT = 'users/current/sub/ENT',
  UpdateSubUsersENT = 'users/sub/ENT/update',

  //Payment
  AllReceipts = 'payment/receipts/ENT/all',
  AllSubscriptions = 'payment/receipts/subscriptions/all',

  AllReceiptsPUB = 'payment/receipts/PUB/all',

  //Stats
  DashboardCOMWidget = 'stats/dashboard/COM/widget',
  AllStatsCOM = 'stats/dashboard/COM/all',
  DashboardDIRWidget = 'stats/dashboard/DIR/widget',
  AllStatsDIR = 'stats/dashboard/DIR/all',
  DashboardPUBLastMonths = 'stats/dashboard/PUB/last_months',
  DashboardENTLastMonths = 'stats/dashboard/ENT/last_months',

  // Boosts
  AllBoosts = '/boosts/all',
  // Boosts - History
  AllBoostsHistory = '/boosts/history/all',

  //Placeholders
  GetMultiplePlaceholders = 'placeholders/get',
}

export enum StaticPostEndpoints {
  // Auth
  Login = '/auth/login',
  LoginCommercial = '/auth/login/COM',
  LoginDIR = '/auth/login/DIR',
  LoginENT = '/auth/login/ENT',
  LoginPUB = '/auth/login/PUB',

  UpdateUser = '/auth/update',
  UpdateUserCOM = '/auth/update_com',
  UpdateUserCredentials = '/auth/update_credentials',
  UpdateUserPassword = '/auth/update_password',

  SignUpENT = '/auth/register/ENT/signup',
  SignUpProspectENT = '/auth/register/ENT/signup_prospect',

  UploadLogo = '/auth/register/ENT/logo',
  RemoveLogo = '/auth/register/ENT/remove/logo',
  UploadKBIS = '/auth/register/ENT/documents',
  UploadDocPUB = '/auth/register/PUB/documents',

  // Consultations
  Init = 'consultations/create/init',
  AvailableCompanies = 'consultations/available_companies',

  SendDevis = 'consultations/send_devis',
  SendQuestion = 'consultations/send_question',
  SendAnswer = 'consultations/send_answer',

  UpdateDevis = 'consultations/update_devis',

  UpdateNaf = 'consultations/naf/update',

  //Commercial
  CreateCommercial = 'commercial/create',
  UpdateCommercial = 'commercial/update',

  //Company 
  UpdateCompanyNAF = 'company/update/NAF',

  //Company - Pending
  CreatePendingCompany = 'company/pending/create',

  //Entity - Pending
  CreatePendingEntity = 'entity/pending/create',

  // Prospect
  CreateProspect = 'prospect/create',
  CreateAccountFromProspect = 'prospect/create_account',
  CreateProspectFromDIR = 'prospect/create_from_dir',
  // UpdateProspect = 'prospect/update', to be created later
  UpdateProspectStatus = 'prospect/update/status',
  UpdateProspectStatusWithComment = 'prospect/update/status_with_comment',
  SendEmailProspect = 'prospect/send_email',
  AssignProspect = 'prospect/update/assign',
  AssignAllProspects = 'prospect/update/assign_all',
  AssignFromExcel = 'prospect/upload/excel',

  // Form
  SendContactMessage = '/form/contact',

  // Boosts - History
  AddBoostsHistory = '/boosts/history/add',
  RemoveBoostsHistory = '/boosts/history/remove',

  //Payment
  SignatureENT = '/payment/ENT/signature',
  SignatureProspect = '/payment/prospect/signature',
  SignatureConsultPUB = '/payment/PUB/consult/signature',
  
  ValidatePaymentENT = '/payment/ENT/validate',
}
